import React from "react";

const ListSkeleton = ({ rows = 8, avatarSize = 42 }) => (
  <div>
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          borderBottom: "1px solid #f0f0f0",
          gap: 12,
        }}
      >
        <div
          className="contact-skel"
          style={{ width: avatarSize, height: avatarSize, borderRadius: "50%", flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div className="contact-skel" style={{ height: 13, width: 120, borderRadius: 4 }} />
            <div className="contact-skel" style={{ height: 11, width: 40, borderRadius: 4 }} />
          </div>
          <div className="contact-skel" style={{ height: 11, width: "75%", borderRadius: 4 }} />
        </div>
      </div>
    ))}
  </div>
);

export default ListSkeleton;
